/* import __COLOCATED_TEMPLATE__ from './unpin-icon.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const UnpinIcon = templateOnlyComponent<Signature>();
export default UnpinIcon;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationsTable::Icons::UnpinIcon': typeof UnpinIcon;
    'inbox2/conversations-table/icons/unpin-icon': typeof UnpinIcon;
  }
}
